/**
 * Created by slava on 01.08.17.
 */

const CellShineView = cc.Node.extend({
    ctor: function () {
        this._super();

        this.shine = new cleverapps.Spine(bundles.shine.jsons.target_json);
        this.addChild(this.shine);

        this.setPosition(cleverapps.styles.BaseCellView.CELL_SIZE_PX / 2, cleverapps.styles.BaseCellView.CELL_SIZE_PX / 2);

        this.prepareForCell();
    },

    prepareForCell: function () {
        this.shine.setAnimation(0, "target", true);

        if (cleverapps.styles.CellShineView.zIndex) {
            this.setLocalZOrder(cleverapps.styles.CellShineView.zIndex);
        }
    },

    reuse: function () {
        this.prepareForCell();
    },

    unuse: function () {
        this.shine.clearTrack(0);
        this.removeFromParent(false);
    }
});

CellShineView.factory = function () {
    // if (cleverapps.pool.hasObject(MarkView)) {
    //     console.log("FROM POOL");
    // }
    return cleverapps.pool.hasObject(CellShineView) ? cleverapps.pool.getFromPool(CellShineView) : new CellShineView();
};

cleverapps.styles.CellShineView = {
    zIndex: 0
};